import {MutationTree} from 'vuex';
import {CategoryState} from '@/store/modules/Category/state';
import {CategoryAPI} from '#/Category';

export const mutations: MutationTree<CategoryState> = {
    ADD_CATEGORY: (state: CategoryState, newCategory: CategoryAPI): boolean | void => {
        let categorySaved = state.categories.find(category => category.id === newCategory.parentCategory);

        if (categorySaved) {
            categorySaved.children?.push(Object.assign({}, newCategory));
        } else {
            state.categories.forEach(category => {
                categorySaved = category.children?.find(category => category.id === newCategory.parentCategory);

                if (categorySaved) {
                    categorySaved.children?.push(Object.assign({}, newCategory));
                    return true;
                }
            });
        }
    },

    DELETE_CATEGORY: (state: CategoryState, categoryId: number): boolean | void => {
        let categorySaved = state.categories.find(category => category.id === categoryId);

        if (categorySaved) {
            state.categories = state.categories.filter(category => category.id !== categoryId);
        } else {
            state.categories.forEach(category => {
                categorySaved = category.children?.find(subCategory => subCategory.id === categoryId);

                if (categorySaved) {
                    category.children = category.children?.filter(subCategory => subCategory.id !== categoryId);
                    return true;
                } else {
                    category.children?.forEach(subCategory => {
                        categorySaved = subCategory.children?.find(subSubCategory => subSubCategory.id === categoryId);

                        if (categorySaved) {
                            subCategory.children = subCategory.children?.filter(subSubCategory => subSubCategory.id !== categoryId);
                            return true;
                        }
                    });
                }
            });
        }
    },

    GET_CATEGORY: (state: CategoryState, categories: CategoryAPI[]) => {
        state.categories = categories;
        state.flattenCategories = categories.reduce<CategoryAPI[]>(
            (acc, rootCat) => acc.concat(
                rootCat,
                rootCat.children?.reduce<CategoryAPI[]>(
                    (acc, cat) => acc.concat(cat, cat.children || []), [],
                ) || [],
            ),
            [],
        );
        state.hasEmptyCategories = false;
    },

    UPDATE_CATEGORY: (state: CategoryState, categoryModified: CategoryAPI): void | boolean => {
        let categorySaved = state.categories.find(category => category.id === categoryModified.id);

        if (categorySaved !== undefined) {
            categorySaved.name = categoryModified.name;
        } else {
            state.categories.forEach(category => {
                categorySaved = category.children?.find(subCategory => subCategory.id === categoryModified.id);

                if (categorySaved !== undefined) {
                    categorySaved.name = categoryModified.name;
                    return true;
                } else {
                    category.children?.forEach(subCategory => {
                        categorySaved = subCategory.children?.find(subSubCategory => subSubCategory.id === categoryModified.id);

                        if (categorySaved !== undefined) {
                            categorySaved.name = categoryModified.name;
                            return true;
                        }
                    });
                }
            });
        }
    },
};
